module.exports = __webpack_public_path__ + "static/media/rover-image.cbb45538.png";